import { apiClient } from '../../../shared/api/axios-instance';

export interface ProductAttribute {
  id: number;
  product_id: number;
  group_id?: number;
  unit_id?: number;
  purpose_id: number;
  input_type_id: number;
  code: string;
  name: string;
  min_value?: number;
  max_value?: number;
  step_value?: number;
  min_length?: number;
  max_length?: number;
  is_required: boolean;
  sort_order: number;
  status: 'active' | 'inactive';
  values?: ProductAttributeValue[];
}

export interface ProductAttributeValue {
  id: number;
  product_attribute_id: number;
  value: string;
  is_default: boolean;
  display_order: number;
  status: 'active' | 'inactive';
}

export const ProductAttributeService = {
  getAttributes: async (productId?: number): Promise<ProductAttribute[]> => {
    const params = productId ? { product_id: productId } : {};
    const response = await apiClient.get('/admin/products/attributes', { params });
    return response.data?.data || [];
  },

  createAttribute: async (data: Partial<ProductAttribute>): Promise<ProductAttribute> => {
    const response = await apiClient.post('/admin/products/attributes', data);
    return response.data?.data;
  },

  updateAttribute: async (id: number, data: Partial<ProductAttribute>): Promise<ProductAttribute> => {
    const response = await apiClient.put(`/admin/products/attributes/${id}`, data);
    return response.data?.data;
  },

  deleteAttribute: async (id: number): Promise<void> => {
    await apiClient.delete(`/admin/products/attributes/${id}`);
  },

  addValue: async (attributeId: number, data: Partial<ProductAttributeValue>): Promise<ProductAttributeValue> => {
    const response = await apiClient.post(`/admin/products/attributes/${attributeId}/values`, data);
    return response.data?.data;
  },

  removeValue: async (attributeId: number, valueId: number): Promise<void> => {
    await apiClient.delete(`/admin/products/attributes/${attributeId}/values/${valueId}`);
  }
};
